var _objectSpread = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _defineProperty = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var path = require('path');
/*************** This is the store implementation for browser storage ****************/


var Store =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * @param storeInitOpt
   * @param storeInitOpt.storeName {string} store name
   * @param storeInitOpt.storeLocation {string} store path
   * @param storeInitOpt.defaultData {Object} any init data in JSON format
   */
  function Store(storeInitOpt) {
    _classCallCheck(this, Store);

    var _ref = storeInitOpt || {},
        _ref$storeLocation = _ref.storeLocation,
        storeLocation = _ref$storeLocation === void 0 ? __dirname : _ref$storeLocation,
        storeName = _ref.storeName,
        _ref$defaultData = _ref.defaultData,
        defaultData = _ref$defaultData === void 0 ? {} : _ref$defaultData;

    try {
      this.path = path.join(storeLocation, storeName);
    } catch (err) {
      throw Error("Unable to verify store path: " + "".concat(storeLocation).concat(storeName) + ". please provide valid storeLocation with storeName");
    }

    this.storeName = storeName;

    try {
      if (window.localStorage.getItem(this.path) !== null) {
        this.data = JSON.parse(window.localStorage.getItem(this.path));
      } else {
        window.localStorage.setItem(this.path, JSON.stringify(defaultData));
        this.data = defaultData;
      }
    } catch (err) {
      throw Error("Unable to init window.localStorage: " + err);
    }
  }

  _createClass(Store, [{
    key: "set",
    value: function set(key, value) {
      var jsonData = _defineProperty({}, key, value);

      var newData = _objectSpread({}, this.data, jsonData);

      try {
        window.localStorage.setItem(this.path, JSON.stringify(newData));
        this.data = newData;
      } catch (err) {
        throw Error("Unable to set data to window.localStorage: " + err);
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.data[key];
    }
  }]);

  return Store;
}();

module.exports = Store;